import { Component, OnInit, Input, ViewChild, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-number-field[formGroup][propertyName]',
  templateUrl: './number-field.component.html',
  styles: [],
  standalone: false,
})
export class NumberFieldComponent extends BaseFormComponent implements OnInit {

  @Input() maxLength?: number;
  @Input() subText?: string;
  @Input() regular?: boolean;
  @Input() FIELD_SPACING: number
  @Input() LABEL_SPACING: number
  @Input() columns?: number;
  @Input() label2?: string;
  
  @Output() userInput? = new EventEmitter<number>();
  @Output() dataInput? = new EventEmitter<number>();

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

  ngOnInit() {
    super.ngOnInit();
    if ( this.maxLength == null ) {
      this.maxLength = 45; // Default field length
    }
  }

  userAction(input: number) {
    if ( this.userInput != null ) {
      this.userInput.emit(input);
    }
  }

  userDataEntryAction(input: number){
    if ( this.dataInput != null ) {
      this.dataInput.emit(input);
    }
  }

}
